import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { StockTakeService }      from './stock-take.service';

angular.module('app-lite.stock-take', [])
  .service('stockTakeApi', downgradeInjectable(StockTakeService));
